// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KeywordCardInfo_container__d14aQ {
  padding: 20px;
  border: 1px solid var(--light-grey);
  color: var(--dark-grey);
  font-size: 16px;
  font-weight: 400;
  display: flex;
  flex-direction: column;
  gap: 24px;
  height: 100%;
}
.KeywordCardInfo_container__d14aQ:hover {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.5);
}
.KeywordCardInfo_container__d14aQ.KeywordCardInfo_selected__ccDQU {
  background-color: var(--accent-color);
  box-shadow: none;
}
.KeywordCardInfo_container__d14aQ.KeywordCardInfo_selected__ccDQU .KeywordCardInfo_hash__7tH4L {
  color: var(--text-0);
}
.KeywordCardInfo_container__d14aQ.KeywordCardInfo_selected__ccDQU .KeywordCardInfo_ranking__JRck2 {
  color: var(--text-0);
}
.KeywordCardInfo_container__d14aQ.KeywordCardInfo_selected__ccDQU .KeywordCardInfo_concept-wrapper__1SVNC .KeywordCardInfo_concept__fvdhl {
  color: var(--text-0);
}
.KeywordCardInfo_container__d14aQ.KeywordCardInfo_selected__ccDQU .KeywordCardInfo_concept-wrapper__1SVNC .KeywordCardInfo_concept-link__FVhJd svg path {
  stroke: var(--text-0);
}
.KeywordCardInfo_container__d14aQ.KeywordCardInfo_selected__ccDQU .KeywordCardInfo_statistics__5PXhb .KeywordCardInfo_statistic__c7luZ svg {
  color: var(--text-0);
}
.KeywordCardInfo_container__d14aQ.KeywordCardInfo_selected__ccDQU .KeywordCardInfo_statistics__5PXhb .KeywordCardInfo_statistic__c7luZ svg path {
  stroke: var(--text-0);
}
.KeywordCardInfo_container__d14aQ.KeywordCardInfo_selected__ccDQU .KeywordCardInfo_statistics__5PXhb .KeywordCardInfo_statistic__label__Codls {
  color: var(--text-0);
}
.KeywordCardInfo_container__d14aQ.KeywordCardInfo_selected__ccDQU .KeywordCardInfo_statistics__5PXhb .KeywordCardInfo_statistic__value__bVzc0 {
  color: var(--text-0);
}
.KeywordCardInfo_container__d14aQ .KeywordCardInfo_hash__7tH4L {
  color: var(--accent-color-medium);
}
.KeywordCardInfo_container__d14aQ .KeywordCardInfo_ranking__JRck2 {
  color: var(--accent-color-dark);
  font-size: 28px;
  font-weight: 700;
}
.KeywordCardInfo_container__d14aQ .KeywordCardInfo_concept-wrapper__1SVNC {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
}
.KeywordCardInfo_container__d14aQ .KeywordCardInfo_concept-wrapper__1SVNC .KeywordCardInfo_concept__fvdhl {
  color: var(--accent-color-dark);
  font-size: 18px;
  font-weight: 600;
}
.KeywordCardInfo_container__d14aQ .KeywordCardInfo_concept-wrapper__1SVNC .KeywordCardInfo_concept-link__FVhJd svg {
  width: 16px;
  height: 16px;
}
.KeywordCardInfo_container__d14aQ .KeywordCardInfo_concept-wrapper__1SVNC .KeywordCardInfo_concept-link__FVhJd svg path {
  stroke: var(--accent-color-dark);
}
.KeywordCardInfo_container__d14aQ .KeywordCardInfo_concept-wrapper__1SVNC .KeywordCardInfo_ranking-wrapper__XOiX3 {
  margin-left: auto;
}
.KeywordCardInfo_container__d14aQ .KeywordCardInfo_statistics__5PXhb {
  margin-top: auto;
}
.KeywordCardInfo_container__d14aQ .KeywordCardInfo_statistics__5PXhb .KeywordCardInfo_statistic__c7luZ {
  display: flex;
  align-items: center;
  gap: 8px;
}
.KeywordCardInfo_container__d14aQ .KeywordCardInfo_statistics__5PXhb .KeywordCardInfo_statistic__c7luZ svg {
  width: 16px;
  height: 16px;
  color: var(--accent-color-dark);
}
.KeywordCardInfo_container__d14aQ .KeywordCardInfo_statistics__5PXhb .KeywordCardInfo_statistic__c7luZ svg path {
  stroke: var(--accent-color-dark);
}
.KeywordCardInfo_container__d14aQ .KeywordCardInfo_statistics__5PXhb .KeywordCardInfo_statistic__content__gSojh {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.KeywordCardInfo_container__d14aQ .KeywordCardInfo_statistics__5PXhb .KeywordCardInfo_statistic__label__Codls {
  color: var(--dark-grey);
  font-size: 12px;
  font-weight: 400;
}
.KeywordCardInfo_container__d14aQ .KeywordCardInfo_statistics__5PXhb .KeywordCardInfo_statistic__value__bVzc0 {
  color: var(--text-1);
  font-size: 14px;
  font-weight: 600;
}
@media only screen and (max-width: 480px) {
  .KeywordCardInfo_container__d14aQ {
    padding: 12px;
    font-size: 14px;
  }
  .KeywordCardInfo_container__d14aQ .KeywordCardInfo_ranking__JRck2 {
    font-size: 24px;
  }
  .KeywordCardInfo_container__d14aQ .KeywordCardInfo_concept-wrapper__1SVNC {
    justify-content: space-between;
  }
  .KeywordCardInfo_container__d14aQ .KeywordCardInfo_concept-wrapper__1SVNC .KeywordCardInfo_concept__fvdhl {
    font-size: 16px;
  }
  .KeywordCardInfo_container__d14aQ .KeywordCardInfo_concept-link__FVhJd svg {
    width: 12px;
    height: 12px;
  }
  .KeywordCardInfo_container__d14aQ .KeywordCardInfo_statistics__5PXhb .KeywordCardInfo_statistic__c7luZ svg {
    width: 12px;
    height: 12px;
  }
  .KeywordCardInfo_container__d14aQ .KeywordCardInfo_statistics__5PXhb .KeywordCardInfo_statistic__label__Codls {
    display: none;
  }
  .KeywordCardInfo_container__d14aQ .KeywordCardInfo_statistics__5PXhb .KeywordCardInfo_statistic__value__bVzc0 {
    font-size: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Components/KeywordCardInfo/KeywordCardInfo.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mCAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;AACF;AACE;EACE,0CAAA;AACJ;AAEE;EACE,qCAAA;EACA,gBAAA;AAAJ;AAEI;EACE,oBAAA;AAAN;AAGI;EACE,oBAAA;AADN;AAKM;EACE,oBAAA;AAHR;AAQU;EACE,qBAAA;AANZ;AAcQ;EACE,oBAAA;AAZV;AAaU;EACE,qBAAA;AAXZ;AAeQ;EACE,oBAAA;AAbV;AAgBQ;EACE,oBAAA;AAdV;AAoBE;EACE,iCAAA;AAlBJ;AAqBE;EACE,+BAAA;EACA,eAAA;EACA,gBAAA;AAnBJ;AAsBE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;AApBJ;AAqBI;EACE,+BAAA;EACA,eAAA;EACA,gBAAA;AAnBN;AAuBM;EACE,WAAA;EACA,YAAA;AArBR;AAuBQ;EACE,gCAAA;AArBV;AA0BI;EACE,iBAAA;AAxBN;AA4BE;EACE,gBAAA;AA1BJ;AA2BI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAzBN;AA2BM;EACE,WAAA;EACA,YAAA;EACA,+BAAA;AAzBR;AA2BQ;EACE,gCAAA;AAzBV;AA6BM;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AA3BR;AA8BM;EACE,uBAAA;EACA,eAAA;EACA,gBAAA;AA5BR;AA+BM;EACE,oBAAA;EACA,eAAA;EACA,gBAAA;AA7BR;AAkCE;EAvIF;IAwII,aAAA;IACA,eAAA;EA/BF;EAiCE;IACE,eAAA;EA/BJ;EAkCE;IACE,8BAAA;EAhCJ;EAiCI;IACE,eAAA;EA/BN;EAmCI;IACE,WAAA;IACA,YAAA;EAjCN;EAuCM;IACE,WAAA;IACA,YAAA;EArCR;EAuCM;IACE,aAAA;EArCR;EAuCM;IACE,eAAA;EArCR;AACF","sourcesContent":[".container {\n  padding: 20px;\n  border: 1px solid var(--light-grey);\n  color: var(--dark-grey);\n  font-size: 16px;\n  font-weight: 400;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  height: 100%;\n\n  &:hover {\n    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 50%);\n  }\n\n  &.selected {\n    background-color: var(--accent-color);\n    box-shadow: none;\n\n    .hash {\n      color: var(--text-0);\n    }\n\n    .ranking {\n      color: var(--text-0);\n    }\n\n    .concept-wrapper {\n      .concept {\n        color: var(--text-0);\n      }\n\n      .concept-link {\n        svg {\n          path {\n            stroke: var(--text-0);\n          }\n        }\n      }\n    }\n\n    .statistics {\n      .statistic {\n        svg {\n          color: var(--text-0);\n          path {\n            stroke: var(--text-0);\n          }\n        }\n\n        &__label {\n          color: var(--text-0);\n        }\n\n        &__value {\n          color: var(--text-0);\n        }\n      }\n    }\n  }\n\n  .hash {\n    color: var(--accent-color-medium);\n  }\n\n  .ranking {\n    color: var(--accent-color-dark);\n    font-size: 28px;\n    font-weight: 700;\n  }\n\n  .concept-wrapper {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 4px;\n    .concept {\n      color: var(--accent-color-dark);\n      font-size: 18px;\n      font-weight: 600;\n    }\n\n    .concept-link {\n      svg {\n        width: 16px;\n        height: 16px;\n\n        path {\n          stroke: var(--accent-color-dark);\n        }\n      }\n    }\n\n    .ranking-wrapper {\n      margin-left: auto;\n    }\n  }\n\n  .statistics {\n    margin-top: auto;\n    .statistic {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n\n      svg {\n        width: 16px;\n        height: 16px;\n        color: var(--accent-color-dark);\n\n        path {\n          stroke: var(--accent-color-dark);\n        }\n      }\n\n      &__content {\n        display: flex;\n        flex-direction: column;\n        gap: 4px;\n      }\n\n      &__label {\n        color: var(--dark-grey);\n        font-size: 12px;\n        font-weight: 400;\n      }\n\n      &__value {\n        color: var(--text-1);\n        font-size: 14px;\n        font-weight: 600;\n      }\n    }\n  }\n\n  @media only screen and (max-width: 480px) {\n    padding: 12px;\n    font-size: 14px;\n\n    .ranking {\n      font-size: 24px;\n    }\n\n    .concept-wrapper {\n      justify-content: space-between;\n      .concept {\n        font-size: 16px;\n      }\n    }\n    .concept-link {\n      svg {\n        width: 12px;\n        height: 12px;\n      }\n    }\n\n    .statistics {\n      .statistic {\n        svg {\n          width: 12px;\n          height: 12px;\n        }\n        &__label {\n          display: none;\n        }\n        &__value {\n          font-size: 14px;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `KeywordCardInfo_container__d14aQ`,
	"selected": `KeywordCardInfo_selected__ccDQU`,
	"hash": `KeywordCardInfo_hash__7tH4L`,
	"ranking": `KeywordCardInfo_ranking__JRck2`,
	"concept-wrapper": `KeywordCardInfo_concept-wrapper__1SVNC`,
	"concept": `KeywordCardInfo_concept__fvdhl`,
	"concept-link": `KeywordCardInfo_concept-link__FVhJd`,
	"statistics": `KeywordCardInfo_statistics__5PXhb`,
	"statistic": `KeywordCardInfo_statistic__c7luZ`,
	"statistic__label": `KeywordCardInfo_statistic__label__Codls`,
	"statistic__value": `KeywordCardInfo_statistic__value__bVzc0`,
	"ranking-wrapper": `KeywordCardInfo_ranking-wrapper__XOiX3`,
	"statistic__content": `KeywordCardInfo_statistic__content__gSojh`
};
export default ___CSS_LOADER_EXPORT___;
